import script from "./NkRessource.vue?vue&type=script&lang=ts&setup=true"
export * from "./NkRessource.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__